import React, { FunctionComponent, useState } from 'react';
import Checkout from 'components/Checkout2';
import { EnrollmentCheckoutProps } from 'hooks/useEnrollmentCheckout';
import { OverFullWindow } from 'components/UI';
import Client from 'pages/Client';

export const EnrollmentCheckoutWrapper: FunctionComponent<EnrollmentCheckoutProps> = ({
    checkoutInfo,
    onClose,
    onPaid
}) => {
    const [clientId, setClientId] = useState<number | null>(null);
    const [hide, setHide] = useState(false);

    if (!checkoutInfo.orderId) {
        return null;
    }

    const handlePaymentSuccess = () => {
        if (onPaid) {
            onPaid();
        }
    };

    const editClientHandler = (clientId: number) => {
        setHide(true);
        setClientId(clientId);
    };

    const closeClientHandler = () => {
        setClientId(null);
        setHide(false);
    };

    return (
        <>
            <Checkout
                orderId={checkoutInfo.orderId}
                type="membership"
                paymentMethods={checkoutInfo.paymentMethods}
                hideTips={true}
                onClose={onClose}
                onBack={onClose}
                onPaid={handlePaymentSuccess}
                onPayByLinkSent={onClose}
                hide={hide}
                onEditClient={editClientHandler}
            />
            {clientId !== null && (
                <OverFullWindow onClose={closeClientHandler}>
                    <Client
                        clientId={clientId}
                        hideHeader={true}
                        onCloseModal={closeClientHandler}
                        onClientSaved={closeClientHandler}
                    />
                </OverFullWindow>
            )}
        </>
    );
};

export default EnrollmentCheckoutWrapper;
